<template>
  <div class="user-management-container">
    <div class="card">
      <h1>用户管理</h1>
      <button class="btn btn-primary" @click="showAddDialog = true">添加用户</button>
      
      <table class="data-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>用户名</th>
            <th>手机号</th>
            <th>到期日期</th>
            <th>所属组</th>
            <th>锁定状态</th>
            <th>审核状态</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="user in users" :key="user.id">
            <td>{{ user.id }}</td>
            <td>{{ user.username }}</td>
            <td>{{ user.mobile }}</td>
            <td>{{ user.expiration_date }}</td>
            <td>{{ user.group?.name || '-' }}</td>
            <td>
              <label class="switch">
                <input 
                  type="checkbox" 
                  v-model="user.is_locked"
                  @change="toggleLockStatus(user)"
                  :checked="user.is_locked"
                >
                <span class="slider round" :class="{ 'active-danger': user.is_locked }"></span>
              </label>
            </td>
            <td>
              <label class="switch">
                <input 
                  type="checkbox" 
                  v-model="user.is_active"
                  @change="toggleActiveStatus(user)"
                  :checked="user.is_active"
                >
                <span class="slider round" :class="{ 'active-success': user.is_active }"></span>
              </label>
            </td>
            <td>
              <button class="btn btn-small" @click="editUser(user)">编辑</button>
              <button class="btn btn-small btn-danger" @click="deleteUser(user.id)">删除</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- 添加用户弹窗 -->
    <div v-if="showAddDialog" class="dialog-overlay">
      <div class="dialog">
        <div class="dialog-header">
          <h3>添加用户</h3>
          <button class="dialog-close" @click="showAddDialog = false">&times;</button>
        </div>
        <div class="dialog-content">
          <form @submit.prevent="submitAdd">
            <div class="form-group">
              <label>用户名</label>
              <input type="text" v-model="newUser.username" class="form-input" placeholder="请输入用户名">
              <span v-if="errors.username" class="error-message">{{ errors.username }}</span>
            </div>
            <div class="form-group">
              <label>手机号</label>
              <input type="tel" v-model="newUser.mobile" class="form-input" placeholder="请输入手机号">
              <span v-if="errors.mobile" class="error-message">{{ errors.mobile }}</span>
            </div>
            <div class="form-group">
              <label>到期日期</label>
              <input type="date" v-model="newUser.expiration_date" class="form-input">
            </div>
            <div class="form-group">
              <label>用户组</label>
              <select v-model="newUser.group_id" class="form-input">
                <option value="">请选择</option>
                <option v-for="group in groups" :key="group.id" :value="group.id">{{ group.name }}</option>
              </select>
              <span v-if="errors.group_id" class="error-message">{{ errors.group_id }}</span>
            </div>
            <div class="form-group">
              <label>
                <input type="checkbox" v-model="newUser.is_locked"> 锁定状态
              </label>
            </div>
            <div class="form-group">
              <label>
                <input type="checkbox" v-model="newUser.is_active"> 审核状态
              </label>
            </div>
          </form>
        </div>
        <div class="dialog-footer">
          <button class="btn" @click="showAddDialog = false">取消</button>
          <button class="btn btn-primary" @click="submitAdd">确认</button>
        </div>
      </div>
    </div>

    <!-- 编辑用户弹窗 -->
    <div v-if="showEditDialog" class="dialog-overlay">
      <div class="dialog">
        <div class="dialog-header">
          <h3>编辑用户</h3>
          <button class="dialog-close" @click="showEditDialog = false">&times;</button>
        </div>
        <div class="dialog-content">
          <form @submit.prevent="submitEdit">
            <div class="form-group">
              <label>用户名</label>
              <input type="text" v-model="editingUser.username" class="form-input" placeholder="请输入用户名">
              <span v-if="errors.username" class="error-message">{{ errors.username }}</span>
            </div>
            <div class="form-group">
              <label>手机号</label>
              <input type="tel" v-model="editingUser.mobile" class="form-input" placeholder="请输入手机号">
              <span v-if="errors.mobile" class="error-message">{{ errors.mobile }}</span>
            </div>
            <div class="form-group">
              <label>到期日期</label>
              <input type="date" v-model="editingUser.expiration_date" class="form-input">
            </div>
            <div class="form-group">
              <label>用户组</label>
              <select v-model="editingUser.group_id" class="form-input">
                <option v-for="group in groups" :key="group.id" :value="group.id">{{ group.name }}</option>
              </select>
              <span v-if="errors.group_id" class="error-message">{{ errors.group_id }}</span>
            </div>
            <div class="form-group">
              <label>
                <input type="checkbox" v-model="editingUser.is_locked"> 锁定状态
              </label>
            </div>
            <div class="form-group">
              <label>
                <input type="checkbox" v-model="editingUser.is_active"> 审核状态
              </label>
            </div>
          </form>
        </div>
        <div class="dialog-footer">
          <button class="btn" @click="showEditDialog = false">取消</button>
          <button class="btn btn-primary" @click="submitEdit">保存</button>
        </div>
      </div>
    </div>

    <!-- 消息提示组件 -->
    <div v-if="message.show" class="message-toast" :class="message.type">
      {{ message.text }}
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      users: [],
      groups: [],
      newUser: { username: '', mobile: '', expiration_date: '', group_id: '', is_locked: false, is_active: true },
      editingUser: null,
      showAddDialog: false,
      showEditDialog: false,
      errors: {},
      message: {
        show: false,
        text: '',
        type: 'success'
      }
    };
  },
  created() {
    this.fetchUsers();
    this.fetchGroups();
  },
  methods: {
    // 显示消息提示
    showMessage(text, type = 'success') {
      this.message = {
        show: true,
        text,
        type
      };
      setTimeout(() => {
        this.message.show = false;
      }, 3000);
    },
    
    // 表单验证
    validateForm(formData) {
      this.errors = {};
      let isValid = true;
      
      if (!formData.username) {
        this.errors.username = '请输入用户名';
        isValid = false;
      }
      
      if (!formData.mobile) {
        this.errors.mobile = '请输入手机号';
        isValid = false;
      }
      
      if (!formData.group_id) {
        this.errors.group_id = '请选择用户组';
        isValid = false;
      }
      
      return isValid;
    },
    
    async fetchUsers() {
      try {
        const res = await axios.get('/api/users');
        this.users = res.data;
      } catch (error) {
        console.error('获取用户列表失败:', error);
        this.showMessage('获取用户列表失败', 'error');
      }
    },
    
    async fetchGroups() {
      try {
        const res = await axios.get('/api/groups',{
          headers: { 'Authorization': `Bearer ${this.$store.getters.token}` },
        });
        this.groups = res.data;
      } catch (error) {
        console.error('获取用户组列表失败:', error);
        this.showMessage('获取用户组列表失败', 'error');
      }
    },
    
    editUser(user) {
      this.editingUser = { ...user };
      this.showEditDialog = true;
    },
    
    async submitAdd() {
      try {
        if (!this.validateForm(this.newUser)) {
          return;
        }
        
        await axios.post('/api/users', this.newUser,{
          headers: {
            'Authorization': `Bearer ${this.$store.getters.token}`
          },
        });
        
        this.showAddDialog = false;
        this.fetchUsers();
        this.newUser = { username: '', mobile: '', expiration_date: '', group_id: '', is_locked: false, is_active: true };
        this.showMessage('用户添加成功');
      } catch (error) {
        this.showMessage(error.response?.data?.detail || '添加用户失败', 'error');
        console.error('添加用户失败:', error);
      }
    },
    
    async submitEdit() {
      try {
        if (!this.validateForm(this.editingUser)) {
          return;
        }
        
        await axios.put(`/api/users/${this.editingUser.id}`, this.editingUser, {
          headers: { 'Authorization': `Bearer ${this.$store.getters.token}` },
        });
        
        this.showEditDialog = false;
        this.fetchUsers();
        this.showMessage('用户编辑成功');
      } catch (error) {
        this.showMessage(error.response?.data?.detail || '编辑用户失败', 'error');
        console.error('编辑用户失败:', error);
      }
    },
    
    async deleteUser(id) {
      if (confirm('确定要删除该用户吗？')) {
        try {
          await axios.delete(`/api/users/${id}`);
          this.fetchUsers();
          this.showMessage('用户删除成功');
        } catch (error) {
          this.showMessage('删除用户失败', 'error');
          console.error('删除用户失败:', error);
        }
      }
    },
    
    async toggleLockStatus(user) {
      try {
        await axios.put(`/api/users/${user.id}`, { is_locked: user.is_locked });
        this.showMessage('锁定状态更新成功');
      } catch (error) {
        this.showMessage('锁定状态更新失败', 'error');
        user.is_locked = !user.is_locked; // 回滚状态
      }
    },
    
    async toggleActiveStatus(user) {
      try {
        await axios.put(`/api/users/${user.id}`, { is_active: user.is_active });
        this.showMessage('审核状态更新成功');
      } catch (error) {
        this.showMessage('审核状态更新失败', 'error');
        user.is_active = !user.is_active; // 回滚状态
      }
    }
  }
};
</script>

<style scoped>
.user-management-container {
  padding: 20px;
}

.card {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.card h1 {
  margin: 0 0 20px 0;
  color: #333;
}

/* 按钮样式 */
.btn {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s;
  margin-right: 10px;
  background-color: #f0f2f5;
  color: #333;
}

.btn:hover {
  opacity: 0.8;
}

.btn-primary {
  background-color: #409eff;
  color: white;
}

.btn-danger {
  background-color: #f56c6c;
  color: white;
}

.btn-small {
  padding: 4px 12px;
  font-size: 12px;
  margin-right: 5px;
}

/* 表格样式 */
.data-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

.data-table th,
.data-table td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #ebeef5;
}

.data-table th {
  background-color: #f0f2f5;
  color: #333;
  font-weight: 600;
}

.data-table tr:hover {
  background-color: #f5f7fa;
}

/* 开关样式 */
.switch {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: .4s;
  border-radius: 24px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: .4s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: #409eff;
}

input:checked + .slider:before {
  transform: translateX(20px);
}

input:checked + .slider.active-success {
  background-color: #13ce66;
}

input:checked + .slider.active-danger {
  background-color: #ff4949;
}

/* 对话框样式 */
.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.3s;
}

.dialog {
  background: white;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  animation: slideIn 0.3s;
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #ebeef5;
}

.dialog-header h3 {
  margin: 0;
  color: #333;
}

.dialog-close {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #909399;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
}

.dialog-close:hover {
  background-color: #f5f7fa;
}

.dialog-content {
  padding: 20px;
}

.dialog-footer {
  padding: 16px 20px;
  text-align: right;
  border-top: 1px solid #ebeef5;
  background-color: #f5f7fa;
  border-radius: 0 0 8px 8px;
}

/* 表单样式 */
.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  color: #333;
  font-weight: 500;
}

.form-input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-size: 14px;
  transition: border-color 0.3s;
  box-sizing: border-box;
}

.form-input:focus {
  outline: none;
  border-color: #409eff;
}

.error-message {
  color: #f56c6c;
  font-size: 12px;
  margin-top: 4px;
  display: block;
}

/* 消息提示样式 */
.message-toast {
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  padding: 12px 20px;
  border-radius: 4px;
  color: white;
  font-size: 14px;
  z-index: 2000;
  animation: slideDown 0.3s;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.message-toast.success {
  background-color: #67c23a;
}

.message-toast.error {
  background-color: #f56c6c;
}

/* 动画 */
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideIn {
  from { transform: translateY(-20px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

@keyframes slideDown {
  from { transform: translate(-50%, -100%); opacity: 0; }
  to { transform: translate(-50%, 0); opacity: 1; }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .data-table {
    display: block;
    overflow-x: auto;
  }
  
  .card {
    padding: 15px;
  }
  
  .dialog {
    width: 95%;
    margin: 20px;
  }
}
</style>
